import { render, staticRenderFns } from "./itemReleaseTypeManageList.vue?vue&type=template&id=5ae13c60&scoped=true"
import script from "./itemReleaseTypeManageList.vue?vue&type=script&lang=js"
export * from "./itemReleaseTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseTypeManageList.vue?vue&type=style&index=0&id=5ae13c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae13c60",
  null
  
)

export default component.exports